import React, {useContext} from "react";
import { isEmpty, startCase } from "lodash";
import dayjs from "dayjs";
import { AiFillEye, AiFillDelete } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helpers from "utils/helpers";
import AuthContext from '../../../context/AuthContext'

const Table = ({ employeeList, handleView, page, sort, setSort, handleDeleteJobRequest }) => {
  const { t } = useTranslation();
  const { user } = useContext(AuthContext)
  const handleColumnSort = (columnName, backendField) => {
    const newSortType = sort.sortBy === backendField && sort.sortType === "asc" ? "desc" : "asc";
    setSort({
      ...sort,
      sortColumn: columnName,
      sortBy: backendField,
      sortType: newSortType
    });
  };

  const getColumnSortIcon = (backendField) => {
    if (sort.sortBy === backendField) {
      return (
        <span>
          {sort.sortType === "asc" && <BsArrowUpShort className="w-4 h-4 ml-1" />}
          {sort.sortType === "desc" && <BsArrowUpShort className="w-4 h-4 rotate-180 ml-1" />}
        </span>
      );
    }
    return null;
  };

  const getShortId = (name, id) =>
  `${name?.slice(0, 3) ?? ''}${id?.slice(-3) ?? ''}`

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                {t("SR_NO")}
              </th>
              {/* <th scope="col" className="py-3 px-6">
                {t("EMPLOYEE_ID")}
              </th> */}
              <th 
                scope="col" 
                className="py-3 px-6"
                onClick={() => handleColumnSort("employee_name", "Employee.name")}
              >
                <div className="flex items-center">
                  {t("EMPLOYEE_NAME")}
                </div>
              </th>
              <th scope="col" className="py-3 px-6">
                {t("O_EMAIL")}
              </th>
              <th 
                scope="col" 
                className="py-3 px-6"
                onClick={() => handleColumnSort("job_title", "Job.name")}
              >
                <div className="flex items-center">
                  {t("JOB_TITLE")}
                </div>
              </th>
              <th 
                scope="col" 
                className="py-3 px-6"
                onClick={() => handleColumnSort("department", "JobDepartment.name")}
              >
                <div className="flex items-center">
                  {t("DEPARTMENT")}
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6"
              >
                <div className="flex items-center">
                  {t("YEAR_OF_EXPERIENCE")}
                </div>
              </th>
              <th
                scope="col"
                className="py-3 px-6 cursor-pointer"
                onClick={() => handleColumnSort("applied_date", "createdAt")}
              >
                <div className="flex items-center">
                  {t("JOB_APPLIED_DATE")}
                  {getColumnSortIcon("createdAt")}
                </div>
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_STATUS")}
              </th>
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {employeeList &&
              employeeList?.map((item, i) => {
                return (
                  <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                    <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900 dark:text-white">
                      {i + 1 + 10 * (page - 1)}
                    </th>
                    {/* <td className="py-4 px-6 border-r text-gray-900">{item?.employmentStatus === "terminated" ? getShortId(user?.name, item?.Employee?._id): item?.Employee?.employeeId} </td> */}
                    <td className="py-4 px-6 border-r text-gray-900"> {item?.Employee?.name}</td>
                    <td className="py-4 px-6 border-r text-gray-900"> {item?.Employee?.email}</td>
                    <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.Job?.name}</td>
                    <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.JobDepartment?.name}</td>
                    <td className="py-4 px-6 border-r text-gray-900 text-left">{item?.yearOfExperiece} </td>
                    <td className="py-4 px-6 border-r text-gray-900 text-left">
                      {dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")} 
                    </td>
                    <td className="py-4 px-6 border-r text-gray-900 text-center">{startCase(item?.employmentStatus === "terminated"? "Terminated" :item?.formStatus)} </td>
                    <td className="py-4 px-6 border-l text-gray-900">
                      <div className="">
                        <ul className="flex justify-center">
                          <li onClick={() => handleView(item)} className="px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer">
                            <a title={t("O_VIEW_USER")}>
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600 hover:text-LightBlue" />{" "}
                            </a>
                          </li>
                          {/* <li
                            onClick={() => {
                              helpers.alertFunction(
                                `Are you sure want to delete job request by '${item?.Employee?.name}'?`,
                                item?._id,
                                handleDeleteJobRequest,
                                true
                              );
                            }}
                            className="px-2 py-2 hover:bg-white hover:text-red-500 cursor-pointer"
                          >
                            <a title={t("O_DELETE_USER")}>
                              <AiFillDelete className="w-5 h-5 text-slate-600 hover:text-red-600" />
                            </a>
                          </li> */}
                        </ul>
                      </div>
                    </td>
                  </tr>
                );
              })}
            {isEmpty(employeeList) ? (
              <tr className="bg-white text-center border-b dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={12}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Table;